"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.empresaConverter = void 0;
const empresaConverter = {
    toFirestore(empresa) {
        return empresa;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            id: data.id,
            idViejaVersion: data.idViejaVersion ?? 0,
            versionFixed: data.versionFixed ?? "0",
            version: data.version,
            nombreComercial: data.nombreComercial,
            rut: data.rut,
            razonSocial: data.razonSocial,
            logoURL: data.logoURL,
            mecanismosEnvioMails: data.mecanismosEnvioMails,
            opcionesGenerales: data.opcionesGenerales,
            opcionesGeneralesFacturacionElectronica: data.opcionesGeneralesFacturacionElectronica,
            opcionesCompras: data.opcionesCompras,
            opcionesGeneralesProductos: data.opcionesGeneralesProductos,
            opcionesGeneralesServicios: data.opcionesGeneralesServicios,
            opcionesGeneralesImpresion: data.opcionesGeneralesImpresion,
            opcionesGeneralesRegimenExonerado: data.opcionesGeneralesRegimenExonerado,
            opcionesGeneralesCamposAdicionales: data.opcionesGeneralesCamposAdicionales,
            fechaRegistro: data.fechaRegistro,
            opcionesVenta: data.opcionesVenta,
            plan: data.plan,
            sucursalesExtra: data.sucursalesExtra,
            cantidadComprobantesEmitidos: data.cantidadComprobantesEmitidos,
            emisorElectronico: data.emisorElectronico,
            codigoPromocional: data.codigoPromocional,
            pagoAnual: data.pagoAnual,
            declaracionBeneficio: data.declaracionBeneficio,
            declaracionBeneficioHistorico: data.declaracionBeneficioHistorico,
            vencimientoFirma: data.vencimientoFirma,
            caeCargados: data.caeCargados ?? false
        };
    }
};
exports.empresaConverter = empresaConverter;
